

const currentEnv =
  "https://api.loadmiles.com/api"; //prod

export const environment = {
  production: true,
  Login_User: 'LOGIN_USER',
  dashboardurl: 'http://localhost:4200/api/dashboard/',
  URL: currentEnv,
  idealTime: 15,
  url: "https://api.loadmiles.com/",//prod
  loginurl: currentEnv + "/user/login",
  companyurl: currentEnv + "/company",
  quickbooksurl: currentEnv + "/quickbooks",
  getcompanydetails: currentEnv + "/company/getCompany",
  userManagementurl: currentEnv + "/companyApi/manageuser",
  companyconfigurationurl: currentEnv + "/companyApi/customSettings",
  trucksurl: currentEnv + "/companyApi/truck",
  trucksAvailurl: currentEnv + "/companyApi/truck/availability",
  truckTypesUrl: currentEnv + "/companyApi/trucktype",
  trailersurl: currentEnv + "/companyApi/trailer",
  trailersAvailurl: currentEnv + "/companyApi/trailer/availability",
  driversurl: currentEnv + "/companyApi/driver",
  driversavalurl: currentEnv + "/companyApi/driver/availability",
  factorurl: currentEnv + "/companyApi/factor",
  factoremail: currentEnv + "/companyApi/invoice/sendInvoice/",
  joburl: currentEnv + "/companyApi/job",
  jobActaulStatementurl: currentEnv + "/companyApi/job/load/viewLoadActualStatement",
  JobSalesStatement: currentEnv + "/companyApi/job/sales/viewJobSalesStatement",
  getStatementJobSalesLineItems: currentEnv + "/companyApi/job/sales/getStatementJobSalesLineItems",
  getPODs: currentEnv + "/companyApi/job/load/getPODs",
  jobdashboardurl: currentEnv + "/companyApi/jobdashboard",
  dispatchersurl: currentEnv + "/companyApi/dispatcher",
  carrierurl: currentEnv + "/companyApi/carrier",
  carrierAvailurl: currentEnv + "/companyApi/carrier/availability",
  customersurl: currentEnv + "/companyApi/customer",
  getloadsurl: currentEnv + "/companyApi/load",
  getloadjourneyurl: currentEnv + "/companyApi/load/loadJourney",
  getloadschedule: currentEnv + "/companyApi/load/loadSchedule",
  getinvoiceurl: currentEnv + "/companyApi/invoice",
  pickupform: currentEnv + "/companyApi/pickup",
  dropoffform: currentEnv + "/companyApi/dropoff",
  getdriverinvoiceurl: currentEnv + "/companyApi/driverpay",
  getcarrierinvoiceurl: currentEnv + "/companyApi/carrierpay",
  getdispatcherinvoiceurl: currentEnv + "/companyApi/dispatcherpay",
  // uploadUrl: "http://3.139.89.46:8081/fileapi/file",
  uploadUrl: currentEnv + "/file",
  postalcodeUrl: "http://3.139.89.46:8081/fileapi/postal_code?postal_code=",
  roledetailsUrl: currentEnv + "/role",
  newcompanyurl: currentEnv + "/company",
  newcompanycreateurl: currentEnv + "/company",
  userdetailsurl: currentEnv + "/user",
  vendorurl: currentEnv + "/companyApi/vendor",
  fuelCardurl: currentEnv + "/companyApi/fuelcard",
  insuranceurl: currentEnv + "/companyApi/insurance",
  incidenturl: currentEnv + "/companyApi/incident",
  currencyurl: currentEnv + "/currency",
  countryurl: currentEnv + "/country/countries",
  stateurl: currentEnv + "/country/states",
  expensetypeurl: currentEnv + "/expense/expensetype",
  expensecategoryurl: currentEnv + "/expense/expensecategory",
  vendorbillsurl: currentEnv + "/companyApi/vendorbill",
  vendorExpensesurl: currentEnv + "/companyApi/tentativeVendorBill",
  bankurl: currentEnv + "/bank",
  paymenttermurl: currentEnv + "/paymentterm",
  forgotpasswordurl: currentEnv + "/user/forgotPassword",
  resetpasswordurl: currentEnv + "/user/resetPassword",
  validateupdatepasswordurl: currentEnv + "/user/validateAndUpdatePassword",
  dwollaurl: currentEnv + "/companyApi/dwolla",
  paymentReceiptUrl: currentEnv + "/companyApi/paymentreceipt",
  settlear: currentEnv + "/companyApi/factor/settlear",
  writeoff: currentEnv + "/companyApi/factor/writeoff",
  paymenthistoryurl: currentEnv + "/companyApi/paymenthistory",
  expenseurl: currentEnv + "/expense/expense",
  expensesurl: currentEnv + "/expense",
  tasklisturl: currentEnv + "/companyApi/tasklist",
  complianceurl: currentEnv + "/companyApi/compliance",
  workorderurl: currentEnv + "/companyApi/workorder",
  payoverviewurl: currentEnv + "/companyApi/payoverview",
  assetperformanceurl: currentEnv + "/companyApi/assetperformance",
  fuelchargeurl: currentEnv + "/companyApi/fuelcharge",
  fiancedatasyncurl: currentEnv + "/companyApi/bcdatasync",
  reporturl: currentEnv + "/companyApi/report",
  budgeturl: currentEnv + "/companyApi/budget",
  producturl: currentEnv + "/product",
  invoicecancellationurl: currentEnv + "/companyApi/invoicecancellationlog",
  deductionurl: currentEnv + "/companyApi/deduction",
  shippingaddressurl: currentEnv + "/companyApi/shippingaddress",
  googleAPIKey: "AIzaSyBInAZ9j4X9Tmh3dXc3FC1C4stlQtH5RQw",
  captchaSiteKey: "6LexzmYcAAAAAA_l-1fm4CZdqDHLbKoEIwoowkbp", //QA
  KC_url: "https://auth.loadmiles.com/",
  KC_Realm: "LoadMiles",
  KC_client: "loadmiles_web",
  getfactoringurl: currentEnv + "/companyApi/factor/invoice",
  createfactorinvoiceurl: currentEnv + "/companyApi/invoice/factoredinvoice",
  trumpurl: currentEnv + "/companyApi/factor/triump",
  invoiceList: currentEnv + "/companyApi/invoice/invoicelist",
  recurringLoad: currentEnv + "/companyApi/recurrentLoad",
  loadschedule: currentEnv + "/companyApi/load/loadSchedule",
  rateconUpload: currentEnv + "/companyApi/ratecon/",
  rateconDetails: currentEnv + "/companyApi/ratecon/rateconDetails/",
  rateconList: currentEnv + "/companyApi/ratecon",
  rateconUpdateStatus: currentEnv + "/companyApi/ratecon/updateStatus",
  rateconEmail:currentEnv + "/companyApi/load/sendLoad",
  carrierRatecon: currentEnv+ "/companyApi/carrier/carrierByEmail/",
  termsAndConditon: currentEnv+ "/companyApi/termsandconditions/",
  getPickDrop: currentEnv+ "/companyApi/load/pickdropList",
  getCounter: currentEnv+ "/companyApi/customSettings/getCounters",
  updateCounter: currentEnv+ "/companyApi/customSettings/updateCounter",
  AttachmentsEmail: currentEnv+ "/companyApi/load/sendFilesAttachment",
  getLoadnumber: currentEnv+ "/companyApi/load/loadNumberList/",
  typeAndSearch: currentEnv+ "/companyApi/typeAndSearch",
  downloadFactorFiles: currentEnv+ "/companyApi/factor/downloadFactorFiles",
  fuelexpenseurl: currentEnv+ "/companyApi/fuelcharge/getList",
  updateFuelExpenseUrl: currentEnv+ "/companyApi/fuelcharge/updateStatus",
  uploadInvoice:currentEnv + "/companyApi/factor/uploadInvoice/",
  updatePickDrop:currentEnv + "/companyApi/",
  sendEmailJob:currentEnv + "/companyApi/job/jobsales/sendEmail",
  rateCardApiUrl: currentEnv + "/companyApi/job/ratecard",
  resourceApiUrl: currentEnv + "/companyApi/job/resource",
  uniTypeApiUrl: currentEnv + "/companyApi/job/unittype",
  getDeliveryPlanUrl: currentEnv + "/companyApi/job/load/getDeliveryPlan",
  getDeliverySummaryUrl :currentEnv + "/companyApi/job/load/getDeliverySummary",
  updateDriverOrCarrierUrl :currentEnv + "/companyApi/job/load/deliveryPlan/updateDriverOrCarrier",
  sendRateconSMS: currentEnv + "/companyApi/load/sendSms",
  downloadExcel: currentEnv + "/companyApi/job/downloadExcel",
  uploadExcel: currentEnv + "/companyApi/job/uploadExcel",
  bulkUpdate: currentEnv + "/companyApi/job/bulk-update",
  backgroundTask: currentEnv + "/background-tasks/",
  emailLogs: currentEnv + "/logs/email",
  jobScheduleReport: currentEnv+ "/companyApi/job/jobschedulereport",
  customerFmcsaurl: currentEnv+ "/companyApi/customer/fmcsa/search",
  deliveryLogs: currentEnv+ "/time-logs",
  showLiveFootage: currentEnv+ "/companyApi/truck/showLiveFootage",
  getDashboardJobs: currentEnv+ "/companyApi/job/jobloadstatuscount",
  jobloadstatuscount: currentEnv+ "/companyApi/job/jobloadstatuscount?loadStatuses=",
  jobunittypecount: currentEnv+ "/companyApi/job/jobunittypecount",
  jobdrivercarrierloadcount: currentEnv+ "/companyApi/job/jobdrivercarrierloadcount",
  deviceAlerts: currentEnv + "/companyApi/alerts",
  availResourceApiUrl: currentEnv+ "/companyApi/job/resource/availableresourcesdashboard",
  availableTrailerdashboardUrl: currentEnv+ "/companyApi/job/resource/availableTrailerdashboard",
  availableTruckdashboardUrl: currentEnv+ "/companyApi/job/resource/availableTruckdashboard",
  availableCarrierdashboardUrl: currentEnv+ "/companyApi/job/resource/availableCarrierdashboard",
  availableDriverdashboardUrl: currentEnv+ "/companyApi/job/resource/availableDriverdashboard",
  dispatchUrl: currentEnv+ "/companyApi/job/dispatch",  
  ticketUrl: currentEnv+ "/companyApi/job/ticket", 
  jobInvoiceUrl: currentEnv+ "/companyApi/job/jobinvoice", 
}
